import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/** Allow access only when not authenticated; redirect to lobby if already signed in. */
export const guestGuard: CanActivateFn = (_route, _state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (!auth.currentUser()) return true;
  return router.createUrlTree(['/']);
};